import BreadCrumbs from "../../common/breadcrumbs";
import Modal from "../../common/Modal";
import Table from "../../common/table";
import ReactTooltip from "react-tooltip";
import Icon from "../../icons/index";
import { useStore } from "../../../zustand/store";
import qs from "qs";
import { Link, useNavigate } from "react-router-dom";
import CS from "../../../services/commonService";
import React, { useState, useEffect } from "react";

import {
	useGetRestaurantPlans,
	useGetSubscriptionPlans,
} from "../../../queryHooks/useSubscriptions";
import { URL } from "../../../constants/URL";
import { useGetRestaurantDetails } from "../../../queryHooks";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import SearchBox from "../../common/searchBox";

//	Pre-defined values
const statusOptions = [
	{ value: "ACTIVE", label: "Active" },
	{ value: "INACTIVE", label: "Inactive" },
	{ value: "EXPIRED", label: "Expired" },
	{ value: "CANCELLED", label: "Cancelled" },
];

const columnKey = "Plans";
//	Component starts
const Subscriptions = () => {
	const navigate = useNavigate();
	//	State values
	const [coupon, setCoupon] = useState({});
	const [open, setOpen] = useState(false);
	const [restaurantList, setRestaurantList] = useState([]);
	const [restaurantModal, setRestaurantModal] = useState(false);
	const [tableData, setTableData] = useState([]);
	const setLoading = useStore((state) => state.setLoading);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [pageNow, setPageNow] = useState(1);
	const [subscriptionsPayload, setSubscriptionsPayload] = useState({
		pagination: true,
		items_per_page: itemsPerPage,
		page: pageNow,
		sort: { created_at: "DESC" },
	});
	const [plansFilterOptions, setPlansFilterOptions] = useState({});
	const closeModal = () => {
		setCoupon({});
		setOpen(false);
	};

	const closeRestaurantModal = () => {
		setRestaurantModal(false);
		setTimeout(() => {
			setRestaurantList([]);
		}, 1000);
	};

	const {
		data: restaurnatSubscriptionPlansData,
		refetch,
		isLoading,
	} = useGetRestaurantPlans(qs.stringify(subscriptionsPayload));
	const { data: subscriptionPlans } = useGetSubscriptionPlans();
	useEffect(() => {
		if (
			restaurnatSubscriptionPlansData &&
			restaurnatSubscriptionPlansData?.status === "success"
		) {
			let respData = restaurnatSubscriptionPlansData?.data;

			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;

			setTableData(respData);
		}
	}, [restaurnatSubscriptionPlansData]);
	useEffect(() => {
		if (subscriptionPlans) {
			const options = subscriptionPlans?.data.records.map((record) => ({
				value: record.id,
				label: record.label,
			}));
			setPlansFilterOptions(options);
		}
	}, [subscriptionPlans]);
	const columns = [
		// rest, plan, status, price,tax,net amt, next billing end at
		{
			label: "Restaurant",
			type: "string",
			path: "name",
			alias: "name",
			content: (item) => (
				<Link to={`../${URL.restaurants}/${item.restaurant_id}`}>
					<div className="d-flex align-items-center">
						<div className="flex-auto">
							{CS.renderImageUrl(item.restaurant?.profile_image_url)}
						</div>
						<div className="d-flex flex-column flex-wrap">
							<span className="pl-2">{item.restaurant?.name}</span>
						</div>
					</div>
				</Link>
			),
		},
		{
			label: "Plan",
			type: "string",
			path: "plan",
			filter: true,
			filterOptions: plansFilterOptions,
			aliasFilter: "subscription_plan_id",
		},
		{
			label: "Status",
			type: "boolean",
			filterOptions: statusOptions,
			path: "status",
			aliasFilter: "status",
		},
		{
			label: "Created At",
			type: "string",
			path: "created_at",
			alias: "subscriptions.created_at",
			sort: true,
			content: (item) => (
				<div className="float-left">
					{getCurrentTimezoneDate(item.created_at)}{" "}
				</div>
			),
		},
		{
			label: "Next Billing At",
			type: "string",
			path: "next_billing_at",
			filterDate: true,
			alias: "next_billing_at",
			content: (item) => (
				<div className="float-left">
					{getCurrentTimezoneDate(item.next_billing_at)}{" "}
				</div>
			),
		},
		{
			label: "Ended At",
			type: "string",
			path: "ended_at",
			alias: "ended_at",
			filterDate: true,
			content: (item) => (
				<div className="float-left"> {item.ended_at ?? "N/A"}</div>
			),
		},

		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<>
					<Icon
						type="show"
						data-tip
						data-for="show"
						onClick={() => {
							navigate("/subscriptions/table", {
								state: {
									restaurant_id: item.restaurant_id,
								},
							});
						}}
					/>
					<ReactTooltip id="show" place="top" effect="solid">
						Show
					</ReactTooltip>
				</>
			),
		},
	];

	return (
		<>
			<BreadCrumbs title="Subscriptions" data={[{ label: "Subscriptions" }]} />
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="left-buttons d-flex my-3">
								<SearchBox
									columnKey={columnKey}
									searchValue={""}
									search={(value) => {
										setPageNow(1);
										setSubscriptionsPayload({
											...subscriptionsPayload,
											search: {
												name: !value && value === "" ? undefined : value,
												"data_restaurants.name":
													!value && value === "" ? undefined : value,
											},
											page: 1,
										});
									}}
								/>
							</div>

							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								sortCol={(obj) => {
									setPageNow(1);
									setSubscriptionsPayload({
										...subscriptionsPayload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setSubscriptionsPayload({
										...subscriptionsPayload,
										page,
									});
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setSubscriptionsPayload({
										...subscriptionsPayload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = await CS.filterData(
											subscriptionsPayload.filter,
											obj
										);
										setPageNow(1);
										setSubscriptionsPayload({
											...subscriptionsPayload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setSubscriptionsPayload({
											...subscriptionsPayload,
											filter: {
												...subscriptionsPayload.filter,
												[obj.alias]: obj.filter,
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setSubscriptionsPayload({
										...subscriptionsPayload,
										filter_date: dates && {
											...subscriptionsPayload?.filter_date,
											[dates.alias]: String(dates.filter),
										},
										page: 1,
									});
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Subscriptions;
